<div
  class="anflex-table-container"
  (paste)="onPasteEvent($event)"
  (copy)="onCopyEvent($event)"
  [ngClass]="templateClasses"
>
  <table
    #table
    [appRangeSelection]="allowSelection"
    class="anflex-table"
    (mouseleave)="disableHoverStateCache()"
    (selectEvent)="triggerSelectionEffects($event)"
  >
    <thead #header class="anflex-table-head">
      <ng-content select="[tableHeaders]"></ng-content>
    </thead>
    <tbody class="anflex-table-body" [ngClass]="{ 'cells-padding': cellsPadding }">
      <ng-content select="[tableRows]"></ng-content>
      <ng-content select="[tableRowCollapse]"></ng-content>
    </tbody>
  </table>

  <div
    *ngIf="enableAddControl || enableDeleteControl"
    class="anflex-table-side-controls"
    [ngClass]="{ 'anflex-table-side-controls--visible': controlsVisibleState }"
    [style.top.px]="getControlsOffset()"
    (mouseover)="enableHoverStateCache()"
    (mouseleave)="disableHoverStateCache()"
  >
    <button
      *ngIf="enableAddControl"
      class="btn-clear has-icon"
      (click)="triggerAddEvent()"
      type="button"
    >
      <i class="fas fa-plus"></i>
    </button>
    <button
      *ngIf="enableDeleteControl"
      class="btn-clear has-icon"
      (click)="triggerDeleteEvent()"
      type="button"
    >
      <i class="fas fa-trash-alt"></i>
    </button>
  </div>
</div>
